module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bloco', {
    staticClass: "-padding-desktop",
    attrs: {
      "id": "coordenadoria"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Coordenadorias")])], 1), _c('div', {
    staticClass: "conteudo",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('carousel', {
    attrs: {
      "paginationEnabled": false,
      "navigationEnabled": true,
      "navigationClickTargetSize": 0,
      "navigationNextLabel": _vm.proximo,
      "navigationPrevLabel": _vm.anterior,
      "perPage": 1,
      "perPageCustom": _vm.breakpoints
    }
  }, [_c('slide', [_c('div', {
    staticClass: "item"
  }, [_c('bloquinho', {
    staticClass: "--turqueza-hover"
  }, [_c('i', {
    staticClass: "fas fa fa-address-book icon-80",
    attrs: {
      "slot": "icone"
    },
    slot: "icone"
  }), _c('template', {
    slot: "sigla"
  }, [_vm._v("CA")]), _c('p', {
    staticClass: "text-center",
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._v("Coordenadoria Administrativa.")])], 2)], 1)]), _c('slide', [_c('div', {
    staticClass: "item"
  }, [_c('bloquinho', {
    staticClass: "--turqueza-hover"
  }, [_c('i', {
    staticClass: "proad proad-onibus",
    attrs: {
      "slot": "icone"
    },
    slot: "icone"
  }), _c('template', {
    slot: "sigla"
  }, [_vm._v("CGT")]), _c('p', {
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._v("A Coordenadoria de Transportes compete, coordenar a gestão da frota de veículos de uso comum e de uso institucional.")])], 2)], 1)]), _c('slide', [_c('div', {
    staticClass: "item"
  }, [_c('bloquinho', {
    staticClass: "--turqueza-hover"
  }, [_c('i', {
    staticClass: "fas fa fa-handshake-o icon-80",
    attrs: {
      "slot": "icone"
    },
    slot: "icone"
  }), _c('template', {
    slot: "sigla"
  }, [_vm._v("CC")]), _c('p', {
    staticClass: "text-center",
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._v("Coordenadoria de Convênios.")])], 2)], 1)]), _c('slide', [_c('div', {
    staticClass: "item"
  }, [_c('bloquinho', {
    staticClass: "--turqueza-hover"
  }, [_c('font-awesome-icon', {
    attrs: {
      "slot": "icone",
      "icon": "archway",
      "size": "4x"
    },
    slot: "icone"
  }), _c('template', {
    slot: "sigla"
  }, [_vm._v("CGEF")]), _c('p', {
    staticClass: "text-center",
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._v("Coordenadoria de Gestão de Espaços Físicos.")])], 2)], 1)]), _c('slide', [_c('div', {
    staticClass: "item"
  }, [_c('bloquinho', {
    staticClass: "--turqueza-hover"
  }, [_c('font-awesome-icon', {
    attrs: {
      "slot": "icone",
      "icon": "sitemap",
      "size": "4x"
    },
    slot: "icone"
  }), _c('template', {
    slot: "sigla"
  }, [_vm._v("CGI")]), _c('p', {
    staticClass: "text-center",
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._v("Coordenadoria de Gestão da Informação.")])], 2)], 1)])], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1b82b00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Coordenadorias.vue
// module id = 513
// module chunks = 0